import { getApiErrorCode } from '@/lib/api/errors';

const UNAUTH_HTTP_STATUSES = new Set([401, 419]);
const UNAUTH_ERROR_CODES = new Set([
  'AUTH.NOT_SIGNED_IN',
  'AUTH.SESSION_EXPIRED',
  'AUTH.UNAUTHENTICATED',
  'SESSION.UNAUTHENTICATED',
]);

const MESSAGE_MARKERS = [
  'unauthorized',
  'unauthenticated',
  'not signed in',
  'session expired',
  '401',
  '419',
];

const hasStatusCode = (error: unknown): number | null => {
  if (!error || typeof error !== 'object') {
    return null;
  }

  const candidate = (error as { status?: unknown }).status;
  if (typeof candidate === 'number') {
    return candidate;
  }

  if (
    'response' in error &&
    error.response &&
    typeof (error as { response: { status?: unknown } }).response.status === 'number'
  ) {
    return (error as { response: { status: number } }).response.status;
  }

  return null;
};

const hasUnauthenticatedMessage = (message: string | null): boolean => {
  if (!message) {
    return false;
  }
  const normalized = message.toLowerCase();
  return MESSAGE_MARKERS.some((marker) => normalized.includes(marker));
};

export const isUnauthenticatedError = (error: unknown): boolean => {
  if (typeof Response !== 'undefined' && error instanceof Response) {
    return UNAUTH_HTTP_STATUSES.has(error.status);
  }

  const status = hasStatusCode(error);
  if (status && UNAUTH_HTTP_STATUSES.has(status)) {
    return true;
  }

  const code = getApiErrorCode(error);
  if (code && UNAUTH_ERROR_CODES.has(code.toUpperCase())) {
    return true;
  }

  const message = typeof error === 'string' ? error : error instanceof Error ? error.message : null;
  return hasUnauthenticatedMessage(message);
};
